export const ANALYSIS_QUESTION_TYPES = {
  normalisation: "Normalisations",
  trend: "Trends",
  accounting_policy: "Accounting Policies",
  other: "Other",
} as const;

export type QnaQuestionType = "source_quality" | keyof typeof ANALYSIS_QUESTION_TYPES;
